module.exports = __webpack_public_path__ + "media/assets/images/front/img-front-3a-ec35bfa728871593a018b659b25dbc2c.png";